import { EN_ZA, EN_IN, EN_GB } from '@clearscore/config.i18n';

const lang = {
    [EN_GB]: {
        mainTitle: 'Log in',
        forgotPassword: 'Forgot password?',
        cantLogin: `Help, I can’t log in`,
        newAccount: 'Create new account',
        rememberMe: 'Remember this browser? Only tick if you’re on your private device.',
        email: {
            placeholder: 'Enter your email',
            label: 'Email',
        },
        password: {
            placeholder: 'Enter your password',
            label: 'Password',
        },
        submit: {
            text: 'Log in',
        },
        securityMessage: '100% Secure & Authorised',
    },
    [EN_ZA]: {
        mainTitle: 'Log in',
        forgotPassword: 'Forgot password?',
        cantLogin: `Help, I can’t log in`,
        newAccount: 'Create new account',
        rememberMe: 'Remember this browser? Only tick if you’re on your private device.',
        email: {
            placeholder: 'Enter your email',
            label: 'Email',
            tabIndex: 1,
        },
        password: {
            placeholder: 'Enter your password',
            label: 'Password',
            tabIndex: 2,
        },
        submit: {
            text: 'Log in',
        },
        securityMessage: '100% Secure & Authorised',
    },
    [EN_IN]: {
        mainTitle: 'Log in',
        forgotPassword: 'Forgot password?',
        cantLogin: `Help, I can’t log in`,
        newAccount: 'Create new account',
        rememberMe: 'Remember this browser? Only tick if you’re on your private device.',
        email: {
            placeholder: 'Enter your email',
            label: 'Email',
            tabIndex: 1,
        },
        password: {
            placeholder: 'Enter your password',
            label: 'Password',
            tabIndex: 2,
        },
        submit: {
            text: 'Log in',
        },
        securityMessage: '100% Secure & Authorised',
    },
};

export default lang;
